import { AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn } from '@angular/forms';
import { catchError, map, of } from 'rxjs';
import { DeviceService } from 'src/app/devices/services/device.service';
import { IBaseSearchRequest } from 'src/app/core/models/base';

export function DeviceEquipmentValidator(deviceService: DeviceService): AsyncValidatorFn {
    return  (control: AbstractControl) => {
        
            // Allow empty values
            if (!control.value) {
                return of(null);
            }

            // dont validate when not touched
            if(control.pristine){
                return of(null);
            }

            const request : IBaseSearchRequest= {
                pageNumber:0,
                pageSize: 999999,
                advancedFilter:{
                    logic: "and",
                    filters: [
                        {
                            field: 'equipmentNumber',
                            operator: 'eq',
                            value: control.value
                        }
                    ]
                }
            }

            // to check for duplicate if its a new device
            var deviceId = control.parent?.get('id')?.value;
            if(deviceId){
                request.advancedFilter.filters.push({
                    field: 'id',
                    operator: 'neq',
                    value: deviceId
                })
            }

            return deviceService.getDevices(request)
            .pipe(
                map(response => {
                    const devices = response.data;
                    return devices.length != 0 ? {equipmentNumberExists: true} : null;
                }),
                catchError(() => of(null)) // Handle errors by returning null
            )
    }
}